import styles from '../../main-nav-bar/mainNavBar.module.scss'
import BtnPrimary from 'components/generic/BtnPrimary'
import { ReactComponent as EmailIcon } from 'images/icons/icn_email.svg'
import { WALK_UP_REG_HREF } from 'constants/global'
import { SubPaths } from 'components/profile/ProfileRouter/ProfileRouter'
import { getOwnProfileUrlWithoutOrigin } from 'utils'
import registrationApi from 'api/rest/registration'
import cx from 'classnames'
import { useTranslation } from 'react-i18next'

export const RegisterBtn = ({ className = '' }: { className?: string }) => {
  const { t } = useTranslation(['strCommonUI'])
  return (
    <button
      onClick={() => registrationApi.redirectToRegister({ enableLogging: true })}
      className={cx(styles.btn, styles.btnPrimary, className)}
    >
      {t('button.register')}
    </button>
  )
}

export const Subscribe = () => {
  const { t } = useTranslation(['strCommonUI'])
  return (
    <BtnPrimary className={styles.btn} controlSubscribeModal>
      <EmailIcon className={styles.btnIcon} />
      {t('button.subscribe')}
    </BtnPrimary>
  )
}

export const PostScore = () => {
  const { t } = useTranslation(['strCommonUI'])
  const href = `${getOwnProfileUrlWithoutOrigin()}${SubPaths.PostScore}`

  return (
    <div>
      <a href={href} className={styles.navLink}>
        {t('button.postAScore')}
      </a>
      <span className={styles.newLabel}>{t('button.new')}</span>
    </div>
  )
}
